<div class="open-status" [ngClass]="{'-inverted': inverted}">
    <div class="open-status__inner">
        <div class="open-status__icon{{openStatus ? ' -status-'+openStatus.status : ''}}"></div>
        <div class="open-status__label">
            {{openStatus?.message}}
        </div>
    </div>
</div>